import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Divider, FormHelperText, Grid, Typography } from "@mui/material";
import { makeStyles } from "../tss";
import Mainlogo from "../images/Logo_Color1.png";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";
import { useFormik } from "formik";
import { useAppDispatch } from "../redux/hooks";
import {
  GET_TEAMDETAILS_BY_ID,
  LOGIN_URL,
  SAVE_DEVICE,
  SSO_AUTHORIZE_URL,
  SSO_CHECK_URL,
} from "../common/url";
import API from "../constants/API";
import { UPDATE_COMPANY_LOGO, UPDATE_USER_PROFILE } from "../redux/action/ActionType";
import {
  DASHBOARD_ROUTE,
  FORGOTPASSWORD_ROUTE,
  SIGNUP_ROUTE,
  UPDATE_PASSWORD_ROUTE,
} from "../constants/RoutePaths";
import { authHeader } from "../common/mainfunction";
import * as Yup from "yup";
import { useSnackbar } from "notistack";
import { CustomMessage } from "../common/helperfunction";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getToken } from "../firebase";
import { useFeatureFlags } from "../context/FeatureFlagContext";
import { usePermissions } from "../context/PermissionContext";

const useStyles = makeStyles((_theme) => ({
  loginbox: {
    backgroundColor: "var(--bg-surface)",
    padding: "30px 50px",
    borderRadius: "16px",
    textAlign: "left",
    boxShadow: "3px 3px 20px #00000017",
  },
  loginbtn: {
    backgroundColor: "#3779EC !important",
    color: "#ffffff !important",
    boxShadow: "none !important",
    textTransform: "none !important",
    "&:hover": {
      color: "#3779EC !important",
      border: "1px solid #3779EC !important",
      backgroundColor: "transparent !important",
      boxShadow: "none !important",
    },
  },
}));

function Signin() {
  const { t } = useTranslation("auth");
  const styleclasses = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const { state = "" } = location;
  const navigation = useNavigate();
  const [PasswordToggle, setPasswordToggle] = useState(true);
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const [_isTokenFound, setTokenFound] = useState(false);
  const { signupEnabled, refreshFlags } = useFeatureFlags();
  const { refreshPermissions } = usePermissions();
  const [ssoAvailable, setSsoAvailable] = useState(false);
  const [searchParams] = useSearchParams();

  const saveFormValues = async (values: any) => {
    setLoading(true);
    const config = {
      method: "POST",
      url: LOGIN_URL,
      data: values,
    };
    try {
      const response = await API(config);
      const { status, data, invoiceCount, exceptionRoleId } = response.data;

      const { accesstoken } = response.headers;

      if (status === "Success") {
        if (data.isDefaultPassword == "0") {
          localStorage.setItem("User_ID", data.userId);
          localStorage.setItem("AUTH_TOKEN", accesstoken);
          localStorage.setItem("Team_ID", data.teamId);
          localStorage.setItem("EMAIL", data.email);
          localStorage.setItem("SENDER_EMAIL", data.invoiceSenderEmail);
          localStorage.setItem("USER_ROLE", data.userRole);
          localStorage.setItem("PROFILE_PIC", data.profileLogo);
          localStorage.setItem("APPROVAL_AMOUNT", data.approvalAmountTo);
          localStorage.setItem("INVOICE_COUNT", invoiceCount);
          localStorage.setItem("BRAND_LOGO", data.companyLogo);
          localStorage.setItem("AUTH_USER_DETAILS", JSON.stringify(data));
          localStorage.setItem("AUTH_2F", "0");
          localStorage.setItem("isException", exceptionRoleId);
          localStorage.setItem("isAddSupplier", data.isAddSupplier);
          localStorage.setItem("LOGIN_NAME", data.firstName + " " + data.lastName);
          localStorage.setItem("PAGE_SIZE_PRESET", data.pageSizePreference || "standard");
          localStorage.setItem("INVOICE_NAV_SCOPE", data.invoiceNavScope || "all");
          localStorage.setItem("API_TIME", new Date().toISOString());
          dispatch({
            type: UPDATE_USER_PROFILE,
            payload: data.profileLogo,
            userName: data.firstName + " " + data.lastName,
          });
          dispatch({
            type: UPDATE_COMPANY_LOGO,
            payload: data.companyLogo,
          });
        }
        if (data.isDefaultPassword == "1") {
          navigation(UPDATE_PASSWORD_ROUTE, {
            state: {
              data: data,
              accesstoken: accesstoken,
              invoiceCount: invoiceCount,
              exceptionRoleId: exceptionRoleId,
            },
          });
        } else {
          await refreshFlags();
          await refreshPermissions();
          if (state) {
            navigation(state.replace(window.location.origin, ""));
          } else {
            navigation(DASHBOARD_ROUTE);
            getTeamDetailsById(data.teamId);
            // saveDevice(data.userId);
          }
        }
      }
    } catch (error) {
      const err = error as {
        response?: { data?: { message?: string; accountExist?: number } };
        message?: string;
      };
      if (err.response) {
        const { data } = err.response;
        const v = data;

        if (v?.accountExist !== 1) {
          CustomMessage(v?.message ?? "Error", "error", enqueueSnackbar); //call toster
          navigation(SIGNUP_ROUTE);
        } else {
          CustomMessage(v?.message ?? "Error", "error", enqueueSnackbar); //call toster
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const getTeamDetailsById = async (id: any) => {
    const config = {
      method: "GET",
      url: GET_TEAMDETAILS_BY_ID,
      headers: authHeader(),
      params: {
        teamId: id,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;

      if (status === "Success") {
        localStorage.setItem("Suppliermaintanceemail", data[0].supplierMaintenanceEmail);
      }
    } catch (error) {
      const err = error as { response?: { data?: { message?: string } }; message?: string };
      if (err.response) {
        const { data } = err.response;
        const parsedErr = data;

        CustomMessage(parsedErr?.message, "error", enqueueSnackbar);
      }
    }
  };

  const _saveDevice = async (id: any) => {
    const config = {
      method: "PUT",
      url: SAVE_DEVICE,
      headers: authHeader(),
      data: {
        userId: id,
        deviceId: localStorage.getItem("Device_ID"),
        isActive: true,
      },
    };
    try {
      await API(config);
    } catch (_error) {
      // saveDevice is fire-and-forget — failures are non-fatal
    }
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email(t("validation.invalidEmail")).required(t("validation.required")),
    password: Yup.string().required(t("validation.required")),
  });

  const { handleSubmit, handleChange, values, handleBlur, errors, touched } = useFormik<
    Record<string, any>
  >({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema,
    onSubmit: (values) => saveFormValues(values),
  });

  const Toogle = () => {
    setPasswordToggle(!PasswordToggle);
  };

  const forGotpassword = () => {
    navigation(FORGOTPASSWORD_ROUTE);
  };

  const gotoSignup = () => {
    navigation(SIGNUP_ROUTE);
  };

  // Check if SSO is enabled on the backend (unauthenticated endpoint)
  useEffect(() => {
    const checkSSO = async () => {
      try {
        const teamId = parseInt(import.meta.env.VITE_TEAM_ID) || 458;
        const config = {
          method: "GET",
          url: SSO_CHECK_URL,
          params: { teamId },
        };
        const response = await API(config);
        const parsed = response.data;

        if (parsed.status === "Success" && parsed.ssoEnabled) {
          setSsoAvailable(true);
        }
      } catch (err) {
        console.error("[SSO] Check failed:", err);
      }
    };
    checkSSO();
  }, []);

  // Show SSO error from callback redirect
  useEffect(() => {
    const ssoError = searchParams.get("sso_error");
    if (ssoError) {
      CustomMessage(ssoError, "error", enqueueSnackbar);
    }
  }, [searchParams, enqueueSnackbar]);

  const handleSSOLogin = () => {
    const teamId = parseInt(import.meta.env.VITE_TEAM_ID) || 458;
    window.location.href = SSO_AUTHORIZE_URL + "?teamId=" + teamId;
  };

  useEffect(() => {
    let data;
    async function tokenFunc() {
      data = await getToken(setTokenFound);
      if (data) {
        localStorage.setItem("Device_ID", data);
      }
      return data;
    }
    tokenFunc();
  }, [setTokenFound]);

  return (
    <>
      <Box className="signin-page" sx={{ width: "100%" }}>
        <Grid
          container
          sx={{ height: "100vh" }}
          rowSpacing={1}
          justifyContent="center"
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          <Grid
            sx={{ margin: "auto" }}
            size={{
              xs: 12,
              md: 4,
            }}
          >
            <Box>
              <img src={Mainlogo} style={{ marginTop: "30px", marginBottom: "20px" }}></img>
            </Box>
            <Box className={styleclasses.loginbox} component={"form"} onSubmit={handleSubmit}>
              <Typography
                sx={{ mt: 1, mb: 3, fontWeight: "600", color: "var(--text-primary)" }}
                align="center"
                variant="h4"
              >
                {t("signin.title")}
              </Typography>
              {ssoAvailable && (
                <>
                  <Box sx={{ textAlign: "center", mb: 2 }}>
                    <Button
                      variant="outlined"
                      onClick={handleSSOLogin}
                      sx={{
                        width: "100%",
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: "15px",
                        padding: "10px 16px",
                        borderColor: "#8c8c8c",
                        color: "#5e5e5e",
                        "&:hover": {
                          borderColor: "#3779EC",
                          color: "#3779EC",
                          backgroundColor: "rgba(55, 121, 236, 0.04)",
                        },
                      }}
                    >
                      <Box
                        component="img"
                        src="https://learn.microsoft.com/en-us/entra/identity-platform/media/howto-add-branding-in-apps/ms-symbollockup_mssymbol_19.png"
                        alt=""
                        sx={{ width: 20, height: 20, mr: 1.5 }}
                      />
                      {t("signin.signInWithMicrosoft")}
                    </Button>
                  </Box>
                  <Divider sx={{ mb: 2, color: "#8c8c8c", fontSize: "13px" }}>
                    {t("signin.orSignInWithEmail")}
                  </Divider>
                </>
              )}
              <Typography gutterBottom sx={{ fontWeight: 600, color: "#4E4B66" }}>
                {t("signin.emailLabel")}
                <Box component={"span"} sx={{ color: "#F14A4A !important" }}>
                  *
                </Box>
              </Typography>
              <FormControl sx={{ width: "100%" }} variant="outlined">
                <OutlinedInput
                  type={"text"}
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  placeholder={t("signin.emailPlaceholder")}
                  onBlur={handleBlur}
                  error={errors.email && touched.email ? true : false}
                />
                <FormHelperText error={true}>
                  {errors.email && touched.email ? String(errors.email) : ""}
                </FormHelperText>
              </FormControl>
              <Typography gutterBottom sx={{ mt: 2, fontWeight: 600, color: "#4E4B66" }}>
                {t("signin.passwordLabel")}
                <Box component={"span"} sx={{ color: "#F14A4A !important" }}>
                  {" "}
                  *
                </Box>
              </Typography>
              <FormControl sx={{ width: "100%" }} variant="outlined">
                <OutlinedInput
                  type={PasswordToggle ? "password" : "text"}
                  value={values.password}
                  onChange={handleChange}
                  name="password"
                  placeholder={t("signin.passwordPlaceholder")}
                  error={errors.password && touched.password ? true : false}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={Toogle}
                        edge="end"
                      >
                        {PasswordToggle ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                <FormHelperText error={true}>
                  {errors.password && touched.password ? String(errors.password) : ""}
                </FormHelperText>
              </FormControl>
              <Box sx={{ textAlign: "right" }}>
                <Button
                  sx={{
                    mt: 2,
                    mb: 3,
                    fontWeight: "600",
                    textDecoration: "none",
                    color: "#ec7c37",
                    textTransform: "capitalize",
                    padding: "0",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                  variant="text"
                  onClick={forGotpassword}
                >
                  {t("signin.forgotPassword")}
                </Button>
              </Box>
              <Box sx={{ textAlign: "center" }}>
                <Button
                  onClick={() => handleSubmit()}
                  variant="contained"
                  disabled={loading}
                  className={styleclasses.loginbtn}
                  type="submit"
                >
                  {t("signin.signInButton")}
                </Button>
              </Box>
            </Box>
            {signupEnabled && (
              <Typography sx={{ mt: 2 }}>
                {t("signin.dontHaveAccount")}
                <Link
                  sx={{ ml: 1, fontWeight: "600", textDecoration: "none" }}
                  color="#793ED6"
                  component="button"
                  variant="body2"
                  onClick={gotoSignup}
                >
                  {t("signin.signUpLink")}
                </Link>
              </Typography>
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default Signin;
